module.exports = __webpack_public_path__ + "static/parade-2020-house28-3751c50c1645878ad4cb9c583f9d8a15.jpg";